// eslint-disable-next-line import/prefer-default-export
export const ROOT_CONTEXT_ID = 'root';
